<template>
  <div>
    <!-- DASHBOARD -->
    <div
      class="nav-menu parent"
      style=" height: 45px; width: 98%; padding: 0px; padding-top: 0.3%; margin-left: 1%; margin-right: 1%;"
    >
      <div class="left-buttons" style="margin-left: 10px">
        <v-menu 
          location="bottom"
          transition="slide-x-transition"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              class="btn"
              variant="text"
              v-bind="props"
            >
              {{ selectedCompanyName }}
              <span class="input-group-addon"
                ><i class="fa fa-chevron-down"></i
              ></span>
            </v-btn>
          </template>

          <div class="mt-4">
            <SelectCompany :companies="companyList" @company_selected="changeCompanyDetails" />
          </div>
        </v-menu>
      </div>
      <div class="filler"></div>
      <img
        src="../img/eboard_Logo_new@2x.png"
        style="height: 75%; width: auto; padding-top: 5px"
        @click="$router.push('/dashboard')"
      />
      <div class="filler"></div>
      <div class="right-buttons">
        <v-menu 
          location="bottom" 
          transition="slide-x-transition"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              class="btn font-weight-bolder"
              variant="text"
              v-bind="props"
            >
              {{ userLanguage.language }}
            </v-btn>
          </template>

          <div class="mt-4 mr-n10">
            <UserLanguage :languages="allLanguages" @language_selected="changeCompanyLanguage" />
          </div>
        </v-menu>
        <v-icon 
          class="mr-4"
          size="x-large"
          color="#ffffff"
          @click="reloadPage"
        >
          mdi-cached
        </v-icon>
        <v-menu 
          location="bottom" 
          :close-on-content-click="false"
          transition="slide-x-transition"
        >
          <template v-slot:activator="{ props }">
            <v-icon 
              class="mr-4"
              size="x-large"
              color="#ffffff"
              v-bind="props"
            >
              mdi-magnify
            </v-icon>
          </template>

          <div class="mt-2">
            <DashboardSearch />
          </div>
        </v-menu>
        <v-menu 
          location="bottom" 
          :close-on-content-click="false"
          transition="slide-x-transition"
        >
          <template v-slot:activator="{ props }">
            <v-avatar rounded="0" size="35" class="mr-4">
              <v-img
                :src="user.userInfo.imageUrl !== '' ? user.userInfo.imageUrl : (gender == 'null' ? '/img/neutral-icon.jpeg' : (gender == 'M' ? '/img/male-icon.png' : '/img/female-icon.png'))"
                style="height: 85px; width: 85px; background-color: #fff; border: 1px solid #27ae60; cursor: pointer;"
                v-bind="props"
              />
            </v-avatar>
          </template>

          <div class="mt-2 mr-n16">
            <UserProfile :dashboard="true" />
          </div>
        </v-menu>
        <v-menu 
          location="bottom"
          transition="slide-x-transition"
        >
          <template v-slot:activator="{ props }">
            <v-icon 
              class="mr-4"
              size="x-large"
              color="#ffffff"
              v-bind="props"
            >
              mdi-server
            </v-icon>
          </template>

          <div class="mt-4 mr-n1">
            <OptionsMenu @contact_support="callTrigger" />
          </div>
        </v-menu>
      </div>
    </div>

    <div>
      <!-- ALERT -->
      <v-alert
        style="margin-left: 1%; margin-right: 1%"
        v-model="alert"
        dismissible
        color="cyan"
        border="left"
        elevation="2"
        colored-border
      >
        <v-btn x-small color="success" @click="reloadPage">
          <span class="text-white">Click Here to Restart</span>
        </v-btn>
      </v-alert>
    </div>

    <div style="display: flex;">
      <div
        class="col-left"
        style="width: 20%; height: 900px; overflow: auto; margin-left: 1%; margin-right: 1%; margin-top: 1%; float: left; position: relative;"
      >
        <div v-if="dashboard_loading">
          <v-progress-linear
            color="info"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </div>

        <div v-if="dashboardMenuList && dashboardMenuList.length > 0">
          <div v-for="(item, index) in even(dashboardMenuList)" :key="index">
            <router-link
              v-if="item.menuTitle !== 'Conference'"
              :to="getMenuRoute(item)"
              style="text-decoration: none"
              :style="{ color: 'rgb(' + item.menuColor + ')' }"
              @click="setCurrentMenu(item)"
            >
              <div
                class="left-menu"
                style="border-top: 5px solid; padding: 3.3%; cursor: pointer;"
                @click="resetComponents"
              >
                <div class="input-group">
                  <span class="input-group-addon">
                    <img
                      v-if="item.menuImageUrl !== ''"
                      v-bind:src="item.menuImageUrl"
                      v-bind:alt="item.userTitle"
                      v-bind:style="{ width: '60px', height: '50px' }"
                    />
                    <v-icon 
                      v-else
                      icon="mdi-image-broken-variant"
                      size="x-large"
                      v-bind:style="{ width: '60px', height: '50px' }"
                    />
                  </span>
                  <v-spacer></v-spacer>
                  <p>{{ item.userTitle ?? item.labelTitle ?? item.menuTitle }}</p>
                </div>
              </div>
            </router-link>
            <div
              v-else
              class="left-menu"
              style="border-top: 5px solid; padding: 3.3%; cursor: pointer;"
              @click="showConferenceModal"
            >
              <div class="input-group">
                <span class="input-group-addon">
                  <img
                    v-bind:src="item.menuImageUrl"
                    v-bind:alt="item.userTitle"
                    v-bind:style="{ width: '60px', height: '50px' }"
                  />
                </span>
                <v-spacer></v-spacer>
                <p>{{ item.userTitle }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="right"
        style="width: 77%; height: 900px; overflow: hidden; margin-right: 1%; margin-top: 1%; float: left; position: relative;"
      >
        <div
          class="col-right-top"
          style="padding: 1%; width: 100%; height: 35%;"
        >
          <div class="input-group" v-if="(dashboardComponent === 'MyInbox') || (dashboardComponent === 'SharedAnnotations')" style="width: 100%; display: flex; align-items: center;">
            <p 
              :style="'margin-left: 20px; margin-right: 20px; font-weight: bold; cursor: pointer; ' 
              + (dashboardComponent === 'MyInbox' ? 'color: #27ae60;' : 'color: #9e9e9e;')"
              @click="swapComponent('MyInbox')"
            >
              My Inbox
            </p>
            <p 
              :style="'margin-left: 20px; margin-right: 20px; font-weight: bold; cursor: pointer; ' 
              + (dashboardComponent === 'Meetings' ? 'color: #27ae60;' : 'color: #9e9e9e;')"
              @click="swapComponent('Meetings')"
            >
              Meetings
            </p>
            <p 
              :style="'margin-left: 20px; margin-right: 20px; font-weight: bold; cursor: pointer; ' 
              + (dashboardComponent === 'SharedAnnotations' ? 'color: #27ae60;' : 'color: #9e9e9e;')"
              @click="swapComponent('SharedAnnotations')"
            >
              Shared
              <v-badge
                color="#27ae60"
                :content="sharedEboardFiles?.length"
                v-if="sharedEboardFiles?.length > 0"
                inline
              ></v-badge>
            </p>
            <v-spacer></v-spacer>
            <p 
              v-if="dashboardComponent === 'Meetings'"
              :style="'margin-left: 20px; margin-right: 20px; font-weight: bold; cursor: pointer; ' 
              + (dashboardComponent === 'Meetings' ? 'color: #27ae60;' : 'color: #9e9e9e;')"
            >
              All
            </p>
          </div>

          <!-- Components Switch -->
          <component 
            :is="dashboardComponent" 
            :recent-documents="getRecentDocumentsArr" 
            @open_document="openDocument"
            @open_pdf="openDocument"
            :load="briefcase"
            :reload="reload"
            :key="dashboardComponent + '-' + reload"
            @trigger_share_dialog="triggerShareDialogOnPSPDFKit"
            @category_changed="getMeetingsForCategory"
            :dashboard-call="true"
          ></component>
          <!-- End of components switch -->
        </div>

        <div
          class="right-bottom"
          style="width: 100%; height: 64%; margin-top: 1%;"
        >
          <div
            class="col-right-bottom-left"
            style="margin-right: 1%; width: 35%; height: 100%; float: left; position: relative; overflow-y: scroll;"
          >
            <div class="input-group" style="width: 100%">
              <v-card elevation="0" color="transparent">
                <v-card-title>
                  <div class="parent">
                    <div class="left-buttons">
                      <v-btn
                        class="text-capitalize"
                        color="#e33333"
                        variant="outlined"
                        size="x-large"
                        style="border: none; pointer-events: none;"
                      >
                        <v-icon
                          size="x-large"
                          icon="mdi-bell-outline"
                          class="mr-2"
                        ></v-icon>
                        {{ switchComponent }}
                      </v-btn>
                    </div>
                    <div class="filler"></div>
                    <div class="left-buttons">
                      <v-btn
                        class="text-capitalize"
                        color="#e33333"
                        variant="outlined"
                        size="x-large"
                        style="border: none; cursor: pointer;"
                        @click="swapSwitchComponent(getComponentText(switchComponent))"
                      >
                        {{ getComponentText(switchComponent) }}
                        <v-icon
                          size="x-large"
                          icon="mdi-chevron-right"
                          class="mr-2"
                        ></v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-card-title>

                <v-card-text>
                  <div style="height: 64vh; overflow: auto; width: 100%">
                    <!-- Components Switch -->
                    <component 
                      :is="switchComponent" 
                      :task-list="getLatestNotificationsArr.taskList" 
                      :signature-list="signatureList"
                      @open_task="selectTask"
                      @open_document="openDocument"
                      @open_pdf="openDocument"
                    ></component>
                    <!-- End of components switch -->
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </div>

          <div
            class="col-right-bottom-right"
            style="padding: 1%; width: 64%; height: 100%; float: left; position: relative; overflow-y: scroll;"
          >
            <FullCalendar :options="calendarOptions" ref="fullCalendar">
              <template v-slot:eventContent="arg">
                <v-tooltip :text="arg.event.title" location="top">
                  <template v-slot:activator="{ props }">
                    <div v-bind="props" v-if="arg.view.type !== 'timeGridDay'">
                      <b>{{ arg.event.title }} ({{ arg.timeText }})</b>
                    </div>

                    <div v-else>
                      <v-card 
                        color="transparent" 
                        elevation="0" 
                        v-if="opened.includes(arg.event.extendedProps.eventId)"
                      >
                        <v-row>
                          <v-col cols="6" md="6" sm="6">
                            <div v-bind="props">
                              <b>{{ arg.event.title }} - {{ arg.event.extendedProps.companyName }}</b>
                            </div>
                          </v-col>

                          <v-col cols="6" md="6" sm="6" :style="'background-color: #FFFFFF; border: 1px solid ' + (arg.event.borderColor) + ';'">     
                            <v-card-text>
                              <v-list>
                                <v-form
                                  ref="form"
                                  v-model="valid"
                                  lazy-validation
                                >
                                  <v-list-item>
                                    <v-list-item-content>
                                      <b :style="'color: ' + arg.event.borderColor + ';'">{{ arg.event.title }}</b>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <span :style="'color: ' + arg.event.borderColor + ';'">Date</span> - {{ formatMeetingDate(arg.event.start) }}
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <span :style="'color: ' + arg.event.borderColor + ';'">Time</span> - {{ arg.timeText }}
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <span :style="'color: ' + arg.event.borderColor + ';'">Event Type</span> - {{ arg.event.extendedProps.eventType.name }}
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <span :style="'color: ' + arg.event.borderColor + ';'">Location</span> - {{ arg.event.extendedProps.location || 'Location not specified' }}
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <span :style="'color: ' + arg.event.borderColor + ';'">Agenda</span> - {{ arg.event.extendedProps.agenda || 'No agenda available' }}
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item v-if="arg.event.extendedProps.eventType.id == 4">
                                    <v-list-item-content>
                                      <span :style="'color: ' + arg.event.borderColor + ';'">Actions</span>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item
                                    v-for="(action, index) in arg.event.extendedProps.eventAction"
                                    :key="index"
                                  >
                                    <v-list-item-content>
                                      <v-btn
                                        class="text-capitalize text-white"
                                        :color="arg.event.borderColor"
                                        :loading="store.getLoading"
                                        @click="submitRSVP(action, arg.event.extendedProps)"
                                      >
                                        {{ action.actionName }}
                                      </v-btn>
                                    </v-list-item-content>

                                    <template v-slot:append v-if="action.isSelected == 1">
                                      <v-icon
                                        :color="arg.event.borderColor"
                                      >
                                        mdi-radiobox-marked</v-icon
                                      >
                                    </template>
                                  </v-list-item>
                                </v-form>
                              </v-list>
                            </v-card-text>
                            <v-card-actions v-if="arg.event.extendedProps.eventType.id == 4">
                              <v-btn
                                block
                                :color="arg.event.borderColor"
                                class="text-capitalize"
                                @click="openCalendarMeeting(arg.event.extendedProps)"
                              >
                                Open Meeting
                              </v-btn>
                            </v-card-actions>
                          </v-col>
                        </v-row>
                      </v-card>

                      <div v-bind="props" v-else>
                        <b>{{ arg.event.title }} ({{ arg.timeText }})</b>
                      </div>
                    </div>
                  </template>
                </v-tooltip>
              </template>
            </FullCalendar>
          </div>
        </div>
      </div>

      <div class="text-center">
        <Conference />
      </div>

      <div class="text-center">
        <UpdateTask 
          @task_updated="getLatestNotifications" 
          :parent-color="'#e33333'"
        />
      </div>

      <!-- CHANGE PASSWORD MODAL -->
      <div v-if="dialog_password">
        <ChangePassword @password_changed="getRequestUserLogin" />
      </div>

      <!-- CONTACT SUPPORT MODAL -->
      <div class="text-center">
        <ContactSupport :load="trigger" />
      </div>

      <!-- DASHBOARD MENUS MODAL -->
      <div class="text-center">
        <DashboardMenus 
          :menus="updatedMenuList" 
          @update_menus="getDashboardMenus"
        />
      </div>

      <div
        v-if="closePDF"
        style="position: absolute; background-color: #f5f5f5; width: 80%; height: 900px; padding: 1%; overflow: hidden; margin-top: 1%; margin-right: 1%; margin-left: 22%; z-index: 2;"
      >
        <v-card>
          <v-card-text>
            <v-main>
              <v-container fluid>
                <pspdfkit
                  :pdf-url="pdf"
                  :license-key="LICENSE_KEY"
                  :document-type="type"
                  :document-title="title"
                  :base-url="baseUrl"
                  @open_pdf="openDocument"
                  @open_document="openDocument"
                  @close_pdf="closePdf"
                  :document-list="getRecentDocumentsArr.recentDocumentsList"
                  :list-color="'rgb(71, 183, 83)'"
                  :document-loader="loading"
                  :briefcase-color="'#e33333'"
                  :briefcase-files="fileIds"
                  :list-width="'25%'"
                  @switch_pdf="switchDocument"
                  @switch_document="switchDocument"
                  :parent_select_type="true"
                  :parent_pdf_type="pdf_type ? 2 : 1"
                  @document_signed="getSignaturesForUser"
                  ref="pspdfkitRef"
                  :open-from-tab="openFromTabNext"
                  @share_dialog_opened="handleShareDialogOpened"
                />
              </v-container>
            </v-main>
          </v-card-text>
        </v-card>
      </div>

      <div
        v-if="closeDocument"
        style="position: absolute; background-color: #f5f5f5; width: 77%; height: 900px; padding: 1%; overflow: hidden; margin-top: 1%; margin-right: 1%; margin-left: 22%; z-index: 2;"
      >
        <v-card>
          <v-card-text>
            <v-main>
              <v-container fluid>
                <DocumentViewer
                  :document-url="pdf"
                  :document-type="type"
                  :document-title="title"
                  :viewer-color="'#e33333'"
                  @open_pdf="openDocument"
                  @open_document="openDocument"
                  @close_document="documentClosed"
                  :document-list="getRecentDocumentsArr.recentDocumentsList"
                  :list-color="'rgb(71, 183, 83)'"
                  :briefcase-color="'#e33333'"
                  :briefcase-files="fileIds"
                  :list-width="'25%'"
                  @switch_pdf="switchDocument"
                  @switch_document="switchDocument"
                  :parent_select_type="true"
                  :parent_pdf_type="pdf_type ? 2 : 1"
                />
              </v-container>
            </v-main>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require("moment");
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import multiMonthPlugin from '@fullcalendar/multimonth';
import axios from "axios";
import PSPDFKit from "../../components/PSPDFKit.vue";
import { useAuthStore } from "../../stores/auth";
import { useIndexStore } from "../../stores/index";
import { useAlertStore } from "../../stores/alert";
import DashboardSearch from '../Cards/DashboardSearch.vue';
import SelectCompany from "../Cards/SelectCompany.vue";
import UserLanguage from "../Cards/UserLanguage.vue";
import UserProfile from '../Cards/UserProfile.vue';
import ChangePassword from '../Forms/ChangePassword.vue';
import Conference from '../Forms/Conference.vue';
import OptionsMenu from "../Forms/OptionsMenu.vue";
import UserData from "../repository/UserData";
import MyInbox from '../Swap/MyInbox.vue';
import Meetings from '../Meetings.vue';
import SharedAnnotations from '../Swap/SharedAnnotations.vue';
import UpdateTask from "../Forms/UpdateTask.vue";
import ContactSupport from '../Forms/ContactSupport.vue';
import DashboardMenus from '../Forms/DashboardMenus.vue';
import DocumentViewer from "../Cards/DocumentViewer.vue";
import GlobalMethods from "../repository/GlobalMethods";
import SlackNotificationChannel from "../repository/SlackNotificationChannel";
import Tasks from "../Swap/Tasks.vue";
import Signatures from "../Swap/Signatures.vue";
import authHeader from "../repository/auth-header";

const LICENSE_KEY =
  "qQQYPHkBJYg9n98YtZGZL2uY8ib3CHb3E8Dj3RiiTPsvgF_qiocO0XxGaMx_V-1uvLcE40JEr4tZSsDWZhtO-kE4S3FCyt27Xq6dR5wn1OjFIkHDPM365GbR59ghBaCcrNSTUss9e84jI29OzS3Rc30eSFTuzDZUYdre2bGu-mQe1ZjLEvTXu5TulbFNuQAsyKf9MgZRngnPpD88kNbCeTRdeQzfnBFOsJxqTrIGwojs6A7D5NTmkUVscajtzr9xrWNnjFBRwj8-e2A13Epd8oBxaEIK8Vp20oxnF5-wg7AqB23xBw7paF1uf626NdYD8EorUPMn4VBazooE2KjD-YOfNwV7lPnJ8Vne4bXfXWUhaRhCsVa2Hvxc-vnhwdXUGAvsyuvHw1XURBtVAnH4lwpUPobPTkeHpRU-I_vISh2DDbgEYdwhk1nckVv-VNAmlym2yw7umI60v8YYGkJ0JQVJ70WiAPz4ySQmVG0Z1X6fdg4mksQwp6rAYetnPykrqmWcFFRm5OWdrypUN0Yfmg_oEWzU-O14MXdfCfoAvjC6fhSboG3DxUMdiXa-Dnycuwf8kgWu_O7JqBHtTGcqdH-lFVaJuQ8ExBYkqZlri49j81PBRT8cJ4yl_vnsi5aCgUSE15CCM2rzCBvPpK6k-g==";

const MODULE_ROUTE_NAME_MAP = {
  BRF: 'Briefcase',
  MTN: 'Meetings',
  MTP: 'Meeting Packs',
  AGN: 'Meeting Packs',
  APP: 'Approvals',
  CMP: 'Compliance',
  EVL: 'Evaluation',
  CNF: 'Conference',
  PLN: 'Plans',
  PRC: 'Procurement',
  RSC: 'Resources',
  DSC: 'Discussion',
  RMN: 'Risk Management',
  ELC: 'Elections',
  'Briefcase': 'Briefcase',
  'Meeting Packs': 'Meeting Packs',
  'Resources': 'Resources',
  'Approvals': 'Approvals',
  'Compliance': 'Compliance',
  'Evaluation': 'Evaluation',
  'Discussion': 'Discussion',
  'Plans': 'Plans',
  'Meetings': 'Meetings',
  'Procurement': 'Procurement',
  'Risk Management': 'Risk Management'
};

const MENU_ID_ROUTE_NAME_MAP = {
  0: 'Briefcase',        // e_Briefcase
  1: 'Meeting Packs',    // e_MeetingPack
  2: 'Resources',        // e_Resources
  3: 'Approvals',        // e_Approvals
  4: 'Compliance',       // e_Compliances
  5: 'Evaluation',       // e_Evaluations
  6: 'Discussion',       // e_Discussions
  7: null,               // e_CompanyLogo (no route)
  8: 'Conference',       // e_Conference
  9: 'Plans',            // e_Plans
  10: 'Procurement',     // e_Contracts
  11: 'Meetings',        // e_MeetingsNew
  12: 'Elections',       // e_Election
  13: 'Risk Management', // e_RiskManagement
  14: 'Procurement',     // e_Procurement
  16: null,              // e_Archives (no route)
  17: null               // e_Petition (no route)
};

export default {
  data: (vm) => ({
    opened: [],
    reload: 0,
    aspectRatio: 16 / 9,
    calendarOptions: {
      plugins: [],
      initialView: 'dayGridMonth',
      events: [],
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'multiMonthYear,dayGridMonth,timeGridDay',
      },
      editable: true,
      selectable: true,
      selectMirror: true,
      dayMaxEvents: true,
      weekends: true,
      eventClick: vm.handleEventClick,
      buttonText: {
        today: 'Today',
        month: 'Month',
        year: 'Year',
        day: 'Day',
        list: 'List'
      },
    },
    currentEvents: [],
    tasks: [],
    notifications: [],
    updatedMenuList: [],
    seen: false,
    seen1: false,
    seen2: false,
    seen3: true,
    seen4: false,
    seen5: false,
    seen6: false,
    dashboard_loading: false,
    test: true,
    closePDF: false,
    closePDF2: false,
    closeDocument: false,
    shareDocument: false,
    showMessages: false,
    dialog: false,
    changePassDiv: false,
    calendarPlugins: [ 
      dayGridPlugin,
      timeGridPlugin,
      interactionPlugin,
      multiMonthPlugin,
    ],
    eboardUpdates: [],
    requestUserLogin: [],
    userInfo: [],
    eventArray: [],
    companyDetail: [],
    userLanguage: [],
    allLanguages: [],
    companyList: [],
    getLatestNotificationsArr: [],
    getRecentDocumentsArr: [],
    getCalendarEventsArr: [],
    checkNames: [],
    companyListId: "",
    selectedCompanyName: "",
    moment: moment,
    date: 1570064727,
    type: "",
    title: "",
    pdf: "example.pdf",
    LICENSE_KEY: LICENSE_KEY,
    baseUrl: "",
    errorMsg: "",
    expiredMessage: "",
    expiredSuccess: "",
    oldPass: "",
    newPass: "",
    confirmPass: "",
    selectedLanguage: "",
    alert: !true,
    userPassword: localStorage.getItem("userPassword") ? JSON.stringify(localStorage.getItem("userPassword")).slice(1, -1) : "",
    token: localStorage.getItem("token") ? JSON.stringify(localStorage.getItem("token")).slice(1, -1) : "",
    store: useIndexStore(),
    auth: useAuthStore(),
    alert_store: useAlertStore(),
    allMeetings: [],
    trigger: false,
    submit_rsvp: false,
    valid: false,
    briefcase: false,
    admin: {},
    globalMethods: GlobalMethods,
    files: [],
    fileIds: [],
    loading: {},
    signatureList: [],
    openFromTabNext: false,
  }),

  filters: {
    moment: function (date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },

  computed: {
    sharedEboardFiles() {
      return this.store.getSharedEboardFiles;
    },

    user() {
      return this.auth.getLoggedInUser;
    },

    dashboardComponent() {
      return this.store.getDashboardComponent;
    },

    switchComponent() {
      return this.store.getSwitchComponent;
    },

    dialog_password() {
      return this.store.getDialogPassword;
    },

    dashboardMenuList: {
      get() {
        return this.auth.getDashboardMenuList;
      },
      set(value) {
        this.auth.setDashboardMenuList(value);
      }
    },

    current_task() {
      return this.store.getCurrentTask;
    },

    gender() {
      return localStorage.getItem('admin_gender');
    },

    pdf_type() {
      return this.store.getPdfType;
    },

    checkEnvironment() {
      return process.env.NODE_ENV == 'production' ? true : false;
    },

    digital_signatures: {
      get() {
        return this.auth.getDigitalSignatures;
      },
      set(value) {
        this.auth.setDigitalSignatures(value);
      },
    },

    session_overlay: {
      get() {
        return this.store.getSessionOverlay;
      },
      set(value) {
        this.store.setSessionOverlay(value);
      },
    },

    reset_session: {
      get() {
        return this.auth.getResetSession;
      },
      set(value) {
        this.auth.setResetSession(value);
      },
    },

    current_menu: {
      get() {
        return this.store.getCurrentMenu;
      },
      set(value) {
        this.store.setCurrentMenu(value);
      },
    },
  },

  methods: {
    getMenuRoute(item) {
      const codeOrTitleKey = item.moduleCode && item.moduleCode.trim() !== '' ? item.moduleCode : item.menuTitle;
      
      const routeFromCodeOrTitle = MODULE_ROUTE_NAME_MAP[codeOrTitleKey] || null;
      const routeFromMenuId = item?.menuId !== undefined && item?.menuId !== null ? MENU_ID_ROUTE_NAME_MAP[Number(item.menuId)] || null : null;

      const routeName = routeFromCodeOrTitle || routeFromMenuId;
      if (!routeName) return { name: 'dashboard' };

      return { name: routeName };
    },

    setCurrentMenu(item) {
      this.current_menu = item;
    },
    
    getFilesWithTopicsFrom() {
      this.store.setSharedEboardFiles([]);
      
      const formData = new FormData();
      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
      formData.append("accessToken", UserData.getAccessToken() ?  UserData.getAccessToken() : this.token);
      formData.append("model", "getFilesWithTopicsFrom");
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);

      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        localStorage.setItem("getFilesWithTopicsFrom", JSON.stringify(response?.data?.data || []));
        this.store.setSharedEboardFiles(response?.data?.data || []);
      })
      .catch((e) => {
        console.log("Error", e);
      });
    },

    formatMeetingDate(date) {
      return moment(date).format("dddd, MMM D, YYYY");
    },

    validate() {
      return this.$refs.form.validate();
    },

    resetForm() {
      return this.$refs.form.reset();
    },

    resetValidation() {
      return this.$refs.form.resetValidation();
    },

    showConferenceModal() {
      this.store.setDialogConference(true);
    },

    selectTask(task) {
      this.store.setCurrentTask(task);
      this.openTaskDialog();
    },

    getComponentText(component) {
      let text = null;
      switch (component) {
        case 'Tasks':
          text = 'Signatures';
          break;
        case 'Signatures':
          text = 'Tasks';
          break;
      }

      return text;
    },

    callTrigger() {
      this.trigger = !this.trigger;
    },

    closePdf() {
      this.briefcase = !this.briefcase;
      this.closePDF = !this.closePDF;
      this.shareDocument = false;
      this.store.setLoading(false);
    },
    
    documentClosed() {
      this.closeDocument = !this.closeDocument;
      this.store.setDialogDocumentViewer(false);
    },

    triggerShareDialogOnPSPDFKit() {
      this.openFromTabNext = true;

      // Wait until PSPDFKit is mounted and ref is available
      this.$nextTick(() => {
        if (this.$refs.pspdfkitRef && typeof this.$refs.pspdfkitRef.openShareDialog === 'function') {
          this.$refs.pspdfkitRef.openShareDialog();
        } else {
          // Try again after a short delay if not yet available
          setTimeout(() => {
            if (this.$refs.pspdfkitRef && typeof this.$refs.pspdfkitRef.openShareDialog === 'function') {
              this.$refs.pspdfkitRef.openShareDialog();
            }
          }, 300);
        }
      });
    },

    handleShareDialogOpened() {
      this.openFromTabNext = false;
    },

    openDocument(item, url = null) {
      if (item.itemExtension != 'No File Extension') {
        this.pdf = item.itemUrl;
        this.type = item.itemExtension;
        this.title = item.itemName;
        UserData.setDocumentId(item.itemId);
        this.store.setDocumentId(item.itemId);
        this.store.setCurrentDocument(item);
        this.store.setBriefcaseUrl(url);

        if (item.itemExtension == "pdf") {
          this.closeDocument = false;
          this.closePDF = true;
          this.store.setCurrentPdf(item);
        } else {
          this.closePDF = false;
          this.closeDocument = true;
          this.store.setDialogDocumentViewer(true);
        }
      } else {
        if (item.itemSize > 0) {
          this.alert_store.showError(item.itemExtension);
        } else {
          this.alert_store.showError('Error Opening File');
        }
      }
    },

    switchDocument(item) {
      this.store.setBriefcaseUrl(null);
      this.openDocument(item);
    },

    briefcaseDocument(item) {
      this.globalMethods.downloadEbrDocument(item.itemUrl).then(async (response) => {
        if (response.status == 200) {
          let fileType = response.headers['content-type'];
          let fileData = new Blob([response.data], { type: fileType });
          let blob = window.URL.createObjectURL(fileData);
          this.openDocument(item, blob);
        } else {
          console.log("Response: ", response);
        }
      }).catch((e) => {
        SlackNotificationChannel.errorMessage(e.message, 'briefcaseDocument(888) in Dashboard.vue', item);
      });
    },

    openPdfOriginal(item) {
      this.closePDF = !this.closePDF;
      this.pdf = item.itemUrl;
    },

    reloadPage() {
      window.location.reload();
    },

    convertDate(date, format) {
      return moment(date).format(format);
    },

    getStartEndDate(date, format) {
      var converted = {};
      // get start and end date for a specific calendar date
      converted['start'] = moment(date).startOf('day').format(format);
      converted['end'] = moment(date).endOf('day').format(format);
      return converted;
    },

    getUserDetails() {
      this.allLanguages = [];
      this.allLanguages = [...this.user.allLanguages];
      this.allLanguages.unshift({
        languageId: "0",
        language: "Select Language",
      });

      this.userInfo = JSON.parse(JSON.stringify(this.user?.userInfo || {}));
      this.companyDetail = JSON.parse(JSON.stringify(this.user?.companyDetail || {}));
      this.userLanguage = JSON.parse(JSON.stringify(this.user?.userLanguage || {}));

      this.auth.setUserLanguage(this.userLanguage);
    },

    getSignaturesForUser() {
      const form = new FormData();
      form.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
      form.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
      form.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
      form.append("model", "getSignaturesForUser");
      form.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);

      axios.post((process.env.NODE_ENV == 'production' ? UserData.getProductionAdminBaseUrl() : UserData.getLocalAdminBaseUrl()) + '/company-signature-files', form, { headers: authHeader()}).then((response) => {
        if (response.status == 200) {
          this.signatureList = response.data.signatureList;
        } else {
          if (response.response.status == 403 && !this.session_overlay) {
            console.log(response);
          }
        }
      });
    },

    checkDigitalSignatures() {
      const form = new FormData();
      form.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
      form.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
      form.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
      form.append("model", "checkDigitalSignatures");
      form.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);

      axios.post((process.env.NODE_ENV == 'production' ? UserData.getProductionAdminBaseUrl() : UserData.getLocalAdminBaseUrl()) + '/check-signatures', form, { headers: authHeader()}).then((response) => {
        if (response.status == 200) {
          const user_digital_signatures = response.data.data;
          if (user_digital_signatures.length > 0 && !this.checkEnvironment) {
            this.digital_signatures = true;
          } else {
            this.digital_signatures = true;
          }
        } else {
          if (response.response.status == 403 && !this.session_overlay) {
            console.log(response);
          }
        }
      });
    },

    getRequestUserLogin() {
      let password = UserData.getUserName() ? UserData.getUserName() : this.user.userInfo.userName;

      const formData = new FormData();
      formData.append("userName", password);
      formData.append("userPassword", password);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
      formData.append("model", "requestUserLogin");
      formData.append("mobileVersion", "11.4.1");
      formData.append("deviceName", "ipad air 2");
      formData.append("eboardVersion", "2.5.7");
      formData.append("wifiName", Math.random().toString(36).slice(2));
      formData.append("userLocation", Math.random().toString(36).slice(2));
      formData.append("deviceToken", Math.random().toString(36).slice(2));
      this.dashboard_loading = true;

      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        this.requestUserLogin = response.data;
        this.dashboard_loading = false;

        this.allLanguages = [];
        this.allLanguages = [...(this.requestUserLogin?.allLanguages || [])];
        this.allLanguages.unshift({
          languageId: "0",
          language: "Select Language",
        });

        this.userInfo = JSON.parse(JSON.stringify(this.requestUserLogin.userInfo || {}));
        this.companyDetail = JSON.parse(JSON.stringify(this.requestUserLogin.companyDetail || {}));
        this.userLanguage = JSON.parse(JSON.stringify(this.requestUserLogin.userLanguage || {}));

        this.auth.setUserLanguage(this.userLanguage);

        const processedMenus = this.requestUserLogin?.dashboardMenuList?.filter(menu => menu.isEnabled == 1 && menu.userEnable == 1)
          ?.sort((a, b) => {
            const getOrder = (item) => {
            if (item.userSortOrder !== null && item.userSortOrder !== undefined && item.userSortOrder !== "") {
              return parseInt(item.userSortOrder, 10);
            }
            
            return parseInt(item.sortOrder, 10);
          };

          return getOrder(a) - getOrder(b);
        });

        this.auth.setDashboardMenuList(JSON.parse(JSON.stringify(processedMenus || [])));
      })
      .catch((error) => {
        console.log(error);
      });
    },
    
    getEboardUpdates() {
      const formData = new FormData();
      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
      formData.append("model", "getEboardUpdates");
      formData.append("mobileVersion", "11.4.1");
      formData.append("deviceName", "ipad air 2");
      formData.append("eboardVersion", "5.3.0");
      formData.append("wifiName", Math.random().toString(36).slice(2));
      formData.append("deviceToken", Math.random().toString(36).slice(2));
      formData.append("accessToken", UserData.getAccessToken() ?  UserData.getAccessToken() : this.token);

      this.dashboard_loading = true;
      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        this.eboardUpdates = response.data;
        this.auth.setEboardUpdates(this.eboardUpdates);
        this.dashboard_loading = false;
      })
      .catch((error) => {
        console.log(error);
      });
    },

    getCompanyName() {
      this.selectedCompanyName = UserData.getCompanyName() ? UserData.getCompanyName() : this.user.companyDetail.companyName;
    },

    getCompanyList() {
      const formData = new FormData();
      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
      formData.append("accessToken", UserData.getAccessToken() ?  UserData.getAccessToken() : this.token);
      formData.append("model", "getCompanyList");
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);

      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        this.getCompanyListArr = response.data;
        this.companyList = this.getCompanyListArr.companyList;

        this.companyList.unshift({
          companyId: "0",
          companyName: "Company List",
        });
      })
      .catch((e) => {
        console.log("Error", e);
      });
    },

    getLatestNotifications() {
      const formData = new FormData();
      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
      formData.append("accessToken", UserData.getAccessToken() ?  UserData.getAccessToken() : this.token);
      formData.append("model", "getLatestNotifications");
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);

      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        this.getLatestNotificationsArr = response.data;
        localStorage.setItem("getLatestNotifications", JSON.stringify(this.getLatestNotificationsArr));
      })
      .catch((e) => {
        console.log("Error", e);
      });
    },

    getRecentDocuments() {
      const formData = new FormData();
      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
      formData.append("accessToken", UserData.getAccessToken() ?  UserData.getAccessToken() : this.token);
      formData.append("model", "getRecentDocuments");
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);

      this.store.setLoading(true);
      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        this.getRecentDocumentsArr = response.data;
        localStorage.setItem("getRecentDocuments", JSON.stringify(this.getRecentDocumentsArr));
        this.store.setLoading(false);
      })
      .catch((e) => {
        console.log("Error", e);
      });
    },

    getCalendarEvents() {
      const formData = new FormData();
      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
      formData.append("accessToken", UserData.getAccessToken() ?  UserData.getAccessToken() : this.token);
      formData.append("model", "getCalendarEvents");
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);

      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        this.getCalendarEventsArr = response.data;
        this.eventArray = this.getCalendarEventsArr.eventList.length > 0 ? this.getCalendarEventsArr.eventList : [];
        localStorage.setItem("getCalendarEvents", JSON.stringify(this.getCalendarEventsArr));
        this.getAllMeetings();

        this.calendarOptions.events = this.eventArray.map((element) => {
          return {
            id: element.eventId,
            title: element.eventTitle,
            start: element.eventType.id == 4 ? this.convertDate(element.eventBeginDate, 'YYYY-MM-DDTHH:mm:ss') : this.getStartEndDate(element.eventBeginDate, 'YYYY-MM-DDTHH:mm:ss')['start'],
            end: element.eventType.id == 4 ? this.convertDate(element.eventEndDate, 'YYYY-MM-DDTHH:mm:ss') : this.getStartEndDate(element.eventBeginDate, 'YYYY-MM-DDTHH:mm:ss')['end'],
            color: element.eventType.color_code || '#56B6E5',
            textColor: "#FFFFFF",
            display: 'block',
            companyId: element.companyId,
            companyName: element.companyName,
            meetingId: element.meetingId,
            eventId: element.eventId,
            module: element.module,
            eventType: element.eventType,
            eventAction: element.eventAction,
            location: element.location,
            eventColor: element.eventColor || '#56B6E5',
          };
        });
      })
      .catch((e) => {
        console.log("Error", e);
      });
    },

    submitRSVP(action, item) {
      let meetingId = item.meetingId;
      this.submit_rsvp = true;
      this.validate().then((validator_response) => {
        this.valid = validator_response.valid;
        if (this.valid && item.eventType.id == 4) {
          const formData = new FormData();
          formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
          formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
          formData.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
          formData.append("model", "sendEventAction");
          formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);
          formData.append("meetingId", meetingId)
          formData.append("eventId", item.eventId);
          formData.append("actionId", action.actionId);
          formData.append("eventType", 2);

          this.store.setLoading(true);
          axios.post(UserData.getBaseUrl(), formData).then((response) => {
            if (response.data.success == 1) {
              action.isSelected = 1;
              this.getCalendarEvents();
              this.store.setLoading(false);
              this.alert_store.showSuccess(response.data.message);
              this.submit_rsvp = false;
            }
          })
          .catch((e) => {
            console.log("Error", e);
            this.store.setLoading(false);
          });
        }
      });
    },

    changeCompanyDetails(item) {
      this.seen1 = false;

      const processedMenus = item.dashboardMenuList?.filter(menu => menu.isEnabled == 1 && menu.userEnable == 1)
        ?.sort((a, b) => {
          const getOrder = (item) => {
            if (item.userSortOrder !== null && item.userSortOrder !== undefined && item.userSortOrder !== "") {
              return parseInt(item.userSortOrder, 10);
            }

            return parseInt(item.sortOrder, 10);
          };

          return getOrder(a) - getOrder(b);
        });

      console.log("Processed Menus: ", processedMenus);
      this.auth.setDashboardMenuList(JSON.parse(JSON.stringify(processedMenus)));
      // Set Repository Company Details
      UserData.setCompanyId(item.companyId);
      UserData.setCompanyName(item.companyName);
      // Set Store Company Details
      this.auth.setCompanyId(item.companyId);
      this.auth.setCompanyName(item.companyName);
      localStorage.setItem('admin_company_id', item.companyId);
      this.closePDF = false;
      this.closeDocument = false;
      this.getEboardUpdates();
      this.getUserDetails();
      this.getCompanyList();
      this.getSignaturesForUser();
      this.checkDigitalSignatures();
      this.getLatestNotifications();
      this.getCalendarEvents();
      this.getRecentDocuments();
      this.selectedCompanyName = UserData.getCompanyName() ? UserData.getCompanyName() : this.user.companyDetail.companyName;
    },

    changeCompanyLanguage(item) {
      const formData = new FormData();
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
      formData.append("accessToken", UserData.getAccessToken() ?  UserData.getAccessToken() : this.token);
      formData.append("model", "changUserLanguage");
      formData.append("lang_id", item.languageId);

      this.store.setLoading(true);
      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        this.selectedLanguage = response.data.userLanguage.language;
        this.auth.setUserLanguage(this.selectedLanguage);
        this.getRequestUserLogin();
        this.store.setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
    },

    langAlert(alert) {
      this.alert = alert;
    },

    getLink() {
      let routeData = this.$router.resolve({
        name: this.getRecentDocumentsArr.recentDocumentsList.itemUrl,
        query: { data: this.getRecentDocumentsArr.recentDocumentsList.itemUrl },
      });
      window.open(routeData.href, "_blank");
    },

    even(dashboardMenuList) {
      return dashboardMenuList.slice();
    },

    sendSharePeople() {
      if (this.checkNames == 0) {
        console.log("Select person(s) to share to");
      } else {
        const formData = new FormData();
        formData.append("document_id", UserData.getDocumentId());
        formData.append("company_code", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
        formData.append("id_users", this.checkNames);

        axios.post("https://v3.stl-horizon.com/pspdfkit/shareAnnotation.php", formData).then((response) => {
          this.sendSharePeopleArray = response.data;
        })
        .catch((e) => {
          console.log("Error", e);
        });

        this.checkNames.length = 0;
        this.shareDocument = false;
      }
    },

    openShareButton() {
      const formData = new FormData();
      formData.append("company_code", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
      formData.append("document_id", UserData.getDocumentId());

      axios.post("https://v3.stl-horizon.com/pspdfkit/shareAnnotation.php", formData).then((response) => {
        this.sharePeople = response.data;
        this.shareDocument = !this.shareDocument;
      })
      .catch((e) => {
        console.log("Error", e);
      });
    },

    getMeetingsForCategory(category = null) {
      this.selectedMeetingCategory = category;

      if (!category || !category.itemId) {
        return;
      }

      this.getAllMeetings(category.itemId);
    },

    getAllMeetings(meetingCategoryId = -999) {
      const formData = new FormData();
      let applyDashboardFilter = 1;

      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
      formData.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
      formData.append("model", "getMeetingForCategory");
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);
      formData.append("meetingCategoryId", meetingCategoryId);
      formData.append("applyDashboardFilter", applyDashboardFilter);
      formData.append("previousMonthFilter", 1);
      formData.append("nextMonthFilter", 4);

      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        if (response.data.data && response.data.data.meetingList && response.data.data.meetingList.length > 0) {
          this.allMeetings = response.data.data.meetingList;
        }
      })
      .catch((e) => {
        console.log("Error", e);
      });
    },

    swapComponent(component) {
      this.store.setDashboardComponent(component);

      if (component == 'SharedAnnotations') {
        ++this.reload;
        this.store.setReload(this.reload);
      }
    },

    swapSwitchComponent(component) {
      this.store.setSwitchComponent(component);
    },

    openDashboard() {
      this.store.setDialogTask(false);
      this.store.setDialogConference(false);
      this.store.setDialogPassword(false);
      this.store.setDashboardComponent('MyInbox');
      this.store.setSwitchComponent('Tasks');
      this.store.setBriefcaseUrl(null);
      this.store.setSignatureDocument(false);
      this.auth.setResetSession(false);
      this.alert_store.setChecked(null);
      this.calendarOptions.plugins = this.calendarPlugins;
      this.calendarOptions.events = this.eventArray;
    },

    openTaskDialog() {
      this.store.setDialogTask(true);
    },

    handleWeekendsToggle() {
      this.calendarOptions.weekends = !this.calendarOptions.weekends;
    },

    handleDateSelect(selectInfo) {
      let title = prompt('Please enter a new title for your event')
      let calendarApi = selectInfo.view.calendar
      calendarApi.unselect() // clear date selection
      if (title) {
        calendarApi.addEvent({
          id: 12,
          title,
          start: selectInfo.startStr,
          end: selectInfo.endStr,
          allDay: selectInfo.allDay
        })
      }
    },

    handleEventClick(clickInfo) {
      if (clickInfo.view.type !== 'timeGridDay') {
        let calendarApi = this.$refs.fullCalendar.getApi();
        calendarApi.changeView('timeGridDay', clickInfo.event.start);
      } 

      if (!this.submit_rsvp) {
        this.toggle(clickInfo.event.extendedProps.eventId);
      }
    },

    toggle(id) {
      const index = this.opened.indexOf(id);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        this.opened = [];
        this.opened.push(id);
      }
    },

    setCurrentMeeting(meeting) {
      this.store.setCurrentMeeting(meeting);
      this.store.setCurrentComponent('view-02');
      this.store.setDashboardComponent('MyInbox');
      this.store.setDashboardMeeting(true);
      this.$router.push('/Meetings');
    },

    handleEvents(events) {
      this.currentEvents = events;
    },

    eventRender(event, element, view) {
      if (view == 'timeGridDay') {
        element.find('.fc-title').append('<div class="hr-line-solid-no-margin"></div><span style="font-size: 10px">' + event.title + '</span></div>');
      }
    },

    getUserInitials(user) {
      const name = user.split(' ');
      return `${name[0].charAt(0)}${name[1] ? name[1].charAt(0) : ''}`;
    },

    resetComponents() {
      this.store.setDashboardComponent('MyInbox');
      this.store.setSwitchComponent('Tasks');
      this.store.setCurrentComponent('view-01');
      this.store.setDashboardMeeting(false);
    },

    openCalendarMeeting(event) {
      if (event.meetingId && event.module) {
        let meetingId = event.meetingId + '_' + event.module;
        this.setCurrentMeeting(this.allMeetings.find(meeting => meeting.itemId == meetingId));
      }
    },
    getDashboardMenus(menuList = []) {
      this.updatedMenuList = menuList || [];
      this.getEboardUpdates();
    },
  },

  beforeMount() {
    this.store.setActivateAiSummary(false);
    this.openDashboard();
    this.getDashboardMenus();
    this.getSignaturesForUser();
    this.checkDigitalSignatures();
    this.getLatestNotifications();
    this.getRecentDocuments();
    this.getCalendarEvents();
    this.getCompanyList();
    this.getCompanyName();
    this.getFilesWithTopicsFrom();

    this.store.setDialogVerifyUser(false);
    this.store.setDialogInkSignature(false);
    this.store.setVerified(false);
    this.store.setCurrentMenu({});
    this.updatedMenuList = this.user?.dashboardMenuList || [];
  },

  components: {
    FullCalendar,
    pspdfkit: PSPDFKit,
    Conference,
    OptionsMenu,
    ChangePassword,
    UserProfile,
    DashboardSearch,
    UserLanguage,
    SelectCompany,
    MyInbox,
    Meetings,
    SharedAnnotations,
    UpdateTask,
    ContactSupport,
    DashboardMenus,
    DocumentViewer,
    Tasks,
    Signatures,
  },
};
</script>

<style scoped>
body {
  padding: 0px;
  margin: 0px;
}

.nav-menu {
  margin-top: 0px;
  background-color: #e33333;
}

.nav-menu .btn {
  background-color: #e33333;
  border: none;
  padding: 0px;
  margin-right: 15px;
  color: white;
  outline: none;
}

.col-left .left-menu {
  background-color: #f5f5f5;
  align-content: center;
  margin-bottom: 10px;
  font-size: 20px;
}

.col-right-top {
  height: 230px;
  background-color: #f5f5f5;
  margin-bottom: 15px;
  padding: 10px;
  border-top: 5px solid #27ae60;
}

.col-right-bottom-left {
  background-color: #f5f5f5;
}

.col-right-bottom-right {
  width: 59%;
  height: 430px;
  background-color: #f5f5f5;
  float: left;
  padding: 1%;
}

.col-right-top .btn {
  padding: 3px;
  width: 100px;
}

.menu-row-icon-six {
  margin: 0px;
  padding: 0px;
  color: #e33333;
}

button:focus {
  outline: 0 !important;
  border: 0 !important;
  box-shadow: none !important;
}

.parent {
  display: flex;
  width: 100%;
  height: auto;
  padding: 2%;
}

.filler {
  flex-grow: 1;
}

p:hover {
  color: #27ae60 !important;
}
</style>